import uk from "./uk.json";
import ru from "./ru.json";
import en from "./en.json";
export const locales = {
  en,
  ru,
  uk,
};
